class Site {
    static unstickOrRestickHeader(restick = false)
    {
        const header = document.getElementById('header-complete-container');
        if (header != null)
        {
            header.style.position = restick ? 'sticky' : 'static';
        }
    }

    static toggleReadMore(button) {
        var categoryTextEl = document.querySelector('.collection__description');
        var buttonText = button.querySelector('.read-more-btn-txt');
        var buttonIcon = button.querySelector('.read-more-btn-icon');
        var currentState = button.dataset.currentState;
        switch (currentState) {
        // text hidden - now show full text
        case 'text_hidden':
            categoryTextEl.classList.add('category-text-expanded');
            button.dataset.currentState = 'text_shown';
            buttonText.innerHTML = 'Read Less';
            buttonIcon.classList.add('fa-chevron-up');
            buttonIcon.classList.remove('fa-chevron-down');
            break;
        // text shown = now hide full text
        case 'text_shown':
            categoryTextEl.classList.remove('category-text-expanded');
            button.dataset.currentState = 'text_hidden';
            buttonText.innerHTML = 'Read More';
            buttonIcon.classList.remove('fa-chevron-up');
            buttonIcon.classList.add('fa-chevron-down');
            break;
        }
    }

    searchAutoCompleteEventListeners()
    {
        const context = this;
        let timeout;

        const searchInputs = document.querySelectorAll('.site-search-input');

        searchInputs.forEach(searchInput => {
            searchInput.addEventListener('input', () => {
                context.toggleAutoCompleteContainer(true);
                clearTimeout(timeout);
                timeout = setTimeout(async () => {
                    context.onSearch(searchInput)
                }, 250);
            });
        });
    }

    toggleAutoCompleteContainer(show = false)
    {
        const searchAutoCompleteContainer = document.querySelector('#search-auto-complete');
        if (show)
        {
            searchAutoCompleteContainer.classList.remove('d-none');
            this.toggleSearchAutoCompleteOverlay(true);
        }
        else {
            searchAutoCompleteContainer.classList.add('d-none');
            this.toggleSearchAutoCompleteOverlay(false);
        }
    }

    onSearch(input)
    {
        const q = input.value; 

        // set view all button
        const viewAllBtn = document.querySelector('#view-all-search-results-btn');
        viewAllBtn.href = `/search?q=${q}`;

        // get and populate product search results
        this.getAndPopulateProductSearch(q);
        // get and populate blog article search results
        this.getAndPopulateBlogSearch(q);
    }

    toggleSearchAutoCompleteOverlay(show = true)
    {
        const overlay = document.querySelector('#search-autocomplete-overlay');
        if (show)
        {
            overlay.classList.remove('d-none');
        }
        else
        {
            overlay.classList.add('d-none');
        }
    }

    getAndPopulateProductSearch(q)
    {
        const productsContainer = document.querySelector('#search-auto-complete_products'); 
        const skeleton = document.querySelector('.skeleton-products');

        skeleton.classList.remove('d-none');
        productsContainer.innerHTML = '';

        // fetch(`/search?q=${q}&type=product&sort_by=best-selling&view=products-ajax`)
        //     .then(response => {
        //         return response.text();
        //     })
        //     .then(data => {
        //         skeleton.classList.add('d-none');
        //         productsContainer.innerHTML = data;
        //     })


        fetch(`/search/suggest?q=${q}}&resources[type]=product&resources[limit]=3&section_id=search-predictive-results`)
        .then(response => response.text())
        .then(html => {
            const doc = new DOMParser().parseFromString(html, 'text/html');

            const inner = doc.querySelector('.shopify-section').innerHTML;
            skeleton.classList.add('d-none');
            productsContainer.innerHTML = inner;
        });
    }

    getAndPopulateBlogSearch(q)
    {
        const blogListContainer = document.querySelector('#search-auto-complete_blog'); 

        fetch(`/search?q=${q}&type=article&view=blog-ajax`)
            .then(response => {
                return response.text();
            })
            .then(data => {
                blogListContainer.innerHTML = data;
            })
    }
}

let site = null;
document.addEventListener('DOMContentLoaded', () => {
    site = new Site();
    site.searchAutoCompleteEventListeners();
});